import {
  hideControl,
  showControl,
  disableControl,
  enableControl,
  showControlBatch,
  hideControlBatch,
  enableControlBatch,
  disableControlBatch,
  lockControl,
  unlockControl,
} from 'core/utils/globalUtils';
import {getAgeInYears} from 'custom/proQuote/utils/data';
import {calcAgeNearest} from 'custom/common/utils/lookupFunctions';
import {DivOptions} from '../report/constants';

import {updateStoreFormSessionData} from './functions';

let pageSelection = {
  chkCoverPage: JSON.parse(sessionStorage.getItem('newBusiness'))
    ? JSON.parse(sessionStorage.getItem('newBusiness')).chkCoverPage
    : true,
  chkTaxPage: JSON.parse(sessionStorage.getItem('newBusiness'))
    ? JSON.parse(sessionStorage.getItem('newBusiness')).chkTaxPage
    : false,
  chkUnderwritingPage: JSON.parse(sessionStorage.getItem('newBusiness'))
    ? JSON.parse(sessionStorage.getItem('newBusiness')).chkUnderwritingPage
    : false,
  chkComplianceNotice: JSON.parse(sessionStorage.getItem('newBusiness'))
    ? JSON.parse(sessionStorage.getItem('newBusiness')).chkComplianceNotice
    : true,
};

let conceptSelection = {
  chkProductCompare: JSON.parse(sessionStorage.getItem('newBusiness'))
    ? JSON.parse(sessionStorage.getItem('newBusiness')).chkProductCompare
    : false,
  chkInternalRoR: JSON.parse(sessionStorage.getItem('newBusiness'))
    ? JSON.parse(sessionStorage.getItem('newBusiness')).chkInternalRoR
    : false,
  chkCharitableGiving: JSON.parse(sessionStorage.getItem('newBusiness'))
    ? JSON.parse(sessionStorage.getItem('newBusiness')).chkCharitableGiving
    : false,
  chkInsuranceInvestment: JSON.parse(sessionStorage.getItem('newBusiness'))
    ? JSON.parse(sessionStorage.getItem('newBusiness')).chkInsuranceInvestment
    : false,
  chkSharedOwnership: JSON.parse(sessionStorage.getItem('newBusiness'))
    ? JSON.parse(sessionStorage.getItem('newBusiness')).chkSharedOwnership
    : false,
};

export function getPageConceptSelection() {
  return {pageSelection, conceptSelection};
}
export function initializePageConceptSelection(formData) {
  let sessData = JSON.parse(sessionStorage.getItem('pageConcept'));
  if (sessData) {
    pageSelection['chkCoverPage'] = sessData.chkCoverPage;
    pageSelection['chkTaxPage'] = sessData.chkTaxPage;
    pageSelection['chkUnderwritingPage'] = sessData.chkUnderwritingPage;
    pageSelection['chkComplianceNotice'] = sessData.chkComplianceNotice;
    conceptSelection['chkProductCompare'] = sessData.chkProductCompare;
    conceptSelection['chkInternalRoR'] = sessData.chkInternalRoR;
    conceptSelection['chkCharitableGiving'] = sessData.chkCharitableGiving;
    conceptSelection['chkInsuranceInvestment'] = sessData.chkInsuranceInvestment;
    conceptSelection['chkSharedOwnership'] = sessData.chkSharedOwnership;
  } else {
    pageSelection['chkCoverPage'] = formData['chkCoverPage'] === 'true' ? true : false;
    pageSelection['chkTaxPage'] = formData['chkTaxPage'] === 'true' ? true : false;
    pageSelection['chkUnderwritingPage'] =
      formData['chkUnderwritingPage'] === 'true' ? true : false;
    pageSelection['chkComplianceNotice'] =
      formData['chkComplianceNotice'] === 'true' ? true : false;
    conceptSelection['chkProductCompare'] = formData['chkProductCompare'] === 'true' ? true : false;
    conceptSelection['chkInternalRoR'] = formData['chkInternalRoR'] === 'true' ? true : false;
    conceptSelection['chkCharitableGiving'] =
      formData['chkCharitableGiving'] === 'true' ? true : false;
    conceptSelection['chkInsuranceInvestment'] =
      formData['chkInsuranceInvestment'] === 'true' ? true : false;
    conceptSelection['chkSharedOwnership'] =
      formData['chkSharedOwnership'] === 'true' ? true : false;
    sessionStorage.setItem('pageConcept', JSON.stringify({...pageSelection, ...conceptSelection}));
  }
}

export function GlobalCustomLostFocus(
  name,
  user,
  controlItems,
  formData,
  elementItems,
  interfaceSetupItems,
  updateFormData,
  updateControlItems,
  inforceData
) {
  //Note: Changing min and max in controlItems will automatically cause a re-Validation through app.js
  switch (name) {
    //Joe: I tried adding the call to the allocation field here but the changes did not refresh the fields/trigger a re-render
    case 'txtProquoteCPBAmount':
      let cpbAmount = parseInt(formData[name]);
      let cpbRemainer = cpbAmount % 1000;
      if (cpbRemainer > 500) {
        cpbAmount = Math.ceil(cpbAmount / 1000) * 1000;
      } else {
        cpbAmount = Math.floor(cpbAmount / 1000) * 1000;
      }
      updateFormData(name, cpbAmount.toString());
      //  formData[name] = cpbAmount.toString();
      // updateStoreFormSessionData(formData, name, cpbAmount.toString());
      break;
    case 'txtProquoteGPOAmount':
      let gpoAmount = parseInt(formData[name]);
      let gpoRemainder = gpoAmount % 1000;
      if (gpoRemainder > 500) {
        gpoAmount = Math.ceil(gpoAmount / 1000) * 1000;
      } else {
        gpoAmount = Math.floor(gpoAmount / 1000) * 1000;
      }
      updateFormData(name, gpoAmount.toString());
      // formData[name] = gpoAmount.toString();
      // updateStoreFormSessionData(formData, name, gpoAmount.toString());
      break;
    default:
      break;
  }
}
export function updateConceptItem(formData, name) {
  conceptSelection[name] = formData[name];
  let sessConcept = JSON.parse(sessionStorage.getItem('pageConcept'));
  sessConcept = {...sessConcept, ...conceptSelection};
  sessionStorage.setItem('pageConcept', JSON.stringify({...sessConcept}));
}

export function GlobalCustomClickBusinessRules(
  name,
  user,
  controlItems,
  formData,
  elementItems,
  interfaceSetupItems,
  allSetupItems,
  updateFormData,
  updateControlItems,
  inforceData
) {
  switch (formData['formName']) {
    case 'ProNeeds':
      proneedsBusinessRules(
        name,
        user,
        controlItems,
        formData,
        elementItems,
        interfaceSetupItems,
        allSetupItems,
        updateFormData,
        updateControlItems,
        inforceData,
        false
      );
      break;
    default:
      break;
  }
  switch (name) {
    case 'btnViewReportNewBiz':
      if (formData['chkProductCompare'] === true) {
        if (
          allSetupItems.compareSetupItem &&
          (formData['txtAge'] < allSetupItems.compareSetupItem['minAge'] ||
            formData['txtAge'] > allSetupItems.compareSetupItem['maxAge'])
        ) {
          // updateFormData('isRunCompare', false);
          // formData['isRunCompare'] = false;
          updateStoreFormSessionData(formData, 'isRunCompare', false);
        } else {
          // updateFormData('isRunCompare', true);
          // formData['isRunCompare'] = true;
          updateStoreFormSessionData(formData, 'isRunCompare', true);
        }
      }
      break;
    case 'btnEditUser':
      controlItems['txtNewUserUsername'].readOnly = true;
      break;
    case 'btnAddUser':
      controlItems['txtNewUserUsername'].readOnly = false;
      break;
    // case 'btnAddDrug':
    //   if (controlItems['txt2c2SubstanceName'].disabled) {
    //   } else if (controlItems['txt2c3SubstanceName'].disabled) {
    //   } else if (controlItems['txt2c4SubstanceName'].disabled) {
    //   } else if (controlItems['txt2c5SubstanceName'].disabled) {
    //   }
    //   break;
    default:
      break;
  }
}

function profileBusinessRules(
  name,
  user,
  controlItems,
  formData,
  elementItems,
  interfaceSetupItems,
  allSetupItems,
  updateFormData,
  updateControlItems,
  inforceData,
  runAll
) {
  switch (name) {
    case 'rdoDefaultApp':
      if (runAll) {
        let optionItems = {};
        if (user.system.isNewBusiness) {
          optionItems['New Business'] = 'Choice-NewBusiness';
        }
        if (user.system.isInforce) {
          optionItems['Inforce'] = 'Choice-Inforce';
        }
        if (user.isAdmin) {
          optionItems['Admin'] = 'Choice-Admin';
        }
        controlItems[name].optionItems = optionItems;
      }
      break;

    default:
      break;
  }
}

function proneedsBusinessRules(
  name,
  user,
  controlItems,
  formData,
  elementItems,
  interfaceSetupItems,
  allSetupItems,
  updateFormData,
  updateControlItems,
  inforceData,
  runAll
) {
  switch (name) {
    case 'chkChildEducationExpense':
      if (!runAll) {
        if (formData[name] === false) {
          hideControlBatch(
            [`cboChild1UniversityStartYear`, `txtChild1TutionAmount`],
            controlItems,
            updateControlItems
          );
          for (let i = 2; i <= 5; i++) {
            hideControlBatch(
              [
                `btnEducation${i}Delete`,
                `cboChild${i}UniversityStartYear`,
                `txtChild${i}TutionAmount`,
              ],
              controlItems,
              updateControlItems
            );
          }
        } else {
          showControlBatch(
            [`cboChild1UniversityStartYear`, `txtChild1TutionAmount`],
            controlItems,
            updateControlItems
          );
          for (let i = 2; i <= 5; i++) {
            if (formData[`btnEducation${i}Delete`] === 'true') {
              hideControlBatch(
                [
                  `btnEducation${i}Delete`,
                  `cboChild${i}UniversityStartYear`,
                  `txtChild${i}TutionAmount`,
                ],
                controlItems,
                updateControlItems
              );
            } else {
              showControlBatch(
                [
                  `btnEducation${i}Delete`,
                  `cboChild${i}UniversityStartYear`,
                  `txtChild${i}TutionAmount`,
                ],
                controlItems,
                updateControlItems
              );
            }
          }
        }
      }
      break;
    case 'cboChild1UniversityStartYear':
    case 'cboChild2UniversityStartYear':
    case 'cboChild3UniversityStartYear':
    case 'cboChild4UniversityStartYear':
    case 'cboChild5UniversityStartYear':
      if (runAll) {
        let currentYear = new Date().getUTCFullYear();
        updateFormData(name, `${currentYear}`);
        controlItems[name].optionItems = buildUniversityYearOptionItems(currentYear);
        controlItems[name].useOptions = true;
      }
      break;
    case 'btnEducation2Delete':
    case 'btnEducation3Delete':
    case 'btnEducation4Delete':
    case 'btnEducation5Delete':
      if (!runAll && formData[name] === 'true') {
        let idx = Number(name.split('')[12]);
        let i = 0;
        for (i = 5; i > idx; i--) {
          if (formData[`btnEducation${i}Delete`] === 'false') {
            break;
          }
        }
        let cboTemp;
        let txtTemp;
        for (let j = idx; j < i; j++) {
          cboTemp = formData[`cboChild${j + 1}UniversityStartYear`];
          txtTemp = formData[`txtChild${j + 1}TutionAmount`];
          updateFormData(`btnEducation${j}Delete`, 'false');
          updateFormData(`cboChild${j}UniversityStartYear`, cboTemp);
          updateFormData(`txtChild${j}TutionAmount`, txtTemp);
        }
        updateFormData(`btnEducation${i}Delete`, 'true');
        updateFormData(`cboChild${i}UniversityStartYear`, '2020');
        updateFormData(`txtChild${i}TutionAmount`, '0');
        updateFormData('btnAddEducationExpense', i);
        hideControlBatch(
          [`btnEducation${i}Delete`, `cboChild${i}UniversityStartYear`, `txtChild${i}TutionAmount`],
          controlItems,
          updateControlItems
        );
      }

      break;
    case 'btnAddEducationExpense':
      if (!runAll) {
        const idx = formData[name];
        formData[`btnEducation${idx}Delete`] = 'false';
        formData[`cboChild${idx}UniversityStartYear`] = '2020';
        formData[`txtChild${idx}TutionAmount`] = '0';
        updateFormData(`btnEducation${idx}Delete`, 'false');
        updateFormData(`cboChild${idx}UniversityStartYear`, '2020');
        updateFormData(`txtChild${idx}TutionAmount`, '0');
        showControlBatch(
          [
            `btnEducation${idx}Delete`,
            `cboChild${idx}UniversityStartYear`,
            `txtChild${idx}TutionAmount`,
          ],
          controlItems,
          updateControlItems
        );
        updateFormData(name, idx + 1);
      }
      break;
    case 'txtAdjustAnnualIncome':
      if (!runAll) {
        updateFormData('txtCurrentNetAnnualIncome', formData[name]);
      }
      break;
    case 'txtAdjustDurationOfIncome':
      if (!runAll) {
        updateFormData('txtDurationOfIncomeForSurvivors', formData[name]);
      }
      break;
    case 'txtCurrentNetAnnualIncome':
      if (!runAll) {
        updateFormData('txtAdjustAnnualIncome', formData[name]);
      }
      break;
    case 'txtDurationOfIncomeForSurvivors':
      if (!runAll) {
        updateFormData('txtAdjustDurationOfIncome', formData[name]);
      }
      break;
    default:
      break;
  }
}
function setSelectBox(name, formData, updateFormData, controlItems) {
  if (!Object.keys(controlItems[name].optionItems).includes(formData[name])) {
    updateFormData(name, Object.keys(controlItems[name].optionItems)[0]);
  }
}
function processMinFaceAmount(formData, controlItems, interfaceSetupItems, intAge) {
  let idx = 0;

  for (idx = 1; idx <= interfaceSetupItems.minFaceBands; idx++) {
    if (
      intAge <= interfaceSetupItems[`band${idx}Max`] ||
      interfaceSetupItems[`band${idx}Max`] === 0
    ) {
      controlItems['txtProquoteFaceAmount'].min = interfaceSetupItems[`band${idx}MinFace`];
      controlItems['txtProquoteFaceAmount'].max = interfaceSetupItems['faceAmountMax'];
      interfaceSetupItems['currentMinFace'] = interfaceSetupItems[`band${idx}MinFace`];
      break;
    }
  }
}
function processADBMaxFaceAmount(formData, controlItems, interfaceSetupItems, intAge) {
  let idx = 0;

  for (idx = 1; idx <= interfaceSetupItems.adbMaxFaceBands; idx++) {
    if (
      intAge <= interfaceSetupItems[`adbBand${idx}Max`] ||
      interfaceSetupItems[`adbBand${idx}Max`] === 0
    ) {
      controlItems['txtProquoteADBAmount'].min = interfaceSetupItems[`adbFaceMin`];
      controlItems['txtProquoteADBAmount'].max = Math.min(
        interfaceSetupItems[`adbBand${idx}MaxFace`],
        formData['txtProquoteFaceAmount']
      );
      if (formData['txtProquoteADBAmount'] > controlItems['txtProquoteADBAmount'].max) {
        formData['txtProquoteADBAmount'] = controlItems['txtProquoteADBAmount'].max.toString();
      }
      interfaceSetupItems['adbCurrentMaxFace'] = interfaceSetupItems[`adbBand${idx}MaxFace`];
      break;
    }
  }
}
function processGPOMaxFaceAmount(formData, controlItems, interfaceSetupItems, intAge) {
  let idx = 0;

  for (idx = 1; idx <= interfaceSetupItems.gpoMaxFaceBands; idx++) {
    if (
      intAge <= interfaceSetupItems[`gpoBand${idx}Max`] ||
      interfaceSetupItems[`gpoBand${idx}Max`] === 0
    ) {
      controlItems['txtProquoteGPOAmount'].min = interfaceSetupItems[`gpoFaceMin`];
      controlItems['txtProquoteGPOAmount'].max = Math.min(
        interfaceSetupItems[`gpoBand${idx}MaxFace`],
        formData['txtProquoteFaceAmount']
      );
      if (formData['txtProquoteGPOAmount'] > controlItems['txtProquoteGPOAmount'].max) {
        formData['txtProquoteGPOAmount'] = controlItems['txtProquoteGPOAmount'].max.toString();
      }
      interfaceSetupItems['gpoCurrentMaxFace'] = interfaceSetupItems[`gpoBand${idx}MaxFace`];
      break;
    }
  }
}
function proquoteBusinessRules(
  name,
  user,
  controlItems,
  formData,
  elementItems,
  interfaceSetupItems,
  allSetupItems,
  updateFormData,
  updateControlItems,
  inforceData,
  runAll
) {
  const ageValue = calcAgeNearest(formData['dtProquoteDob'], new Date());
  const ageString = ageValue.toString();
  switch (name) {
    case 'rdoProquoteTermPolicy':
    case 'rdoProquoteWLPolicy':
      controlItems['txtProquoteCPBAmount'].min = interfaceSetupItems['cpbFaceMin'];
      controlItems['txtProquoteCPBAmount'].max = interfaceSetupItems['cpbFaceMax'];
      // if (Object.keys(controlItems[name].optionItems).length === 0) {
      //   hideControl(name, controlItems, updateControlItems);
      // } else {
      //   showControl(name, controlItems, updateControlItems);
      // }
      if (formData['CurrentField'] === 'rdoProquoteTermPolicy') {
        if (name === 'rdoProquoteTermPolicy' && formData['rdoProquoteTermPolicy'] !== '') {
          formData['rdoProquoteWLPolicy'] = '';
        }
      } else if (formData['CurrentField'] === 'rdoProquoteWLPolicy') {
        if (name === 'rdoProquoteWLPolicy' && formData['rdoProquoteWLPolicy'] !== '') {
          formData['rdoProquoteTermPolicy'] = '';
        }
      }
      processMinFaceAmount(formData, controlItems, interfaceSetupItems, ageValue);
      processADBMaxFaceAmount(formData, controlItems, interfaceSetupItems, ageValue);
      processGPOMaxFaceAmount(formData, controlItems, interfaceSetupItems, ageValue);
      break;

    // case 'cboProquoteProduct':
    //   controlItems['txtProquoteCPBAmount'].min = interfaceSetupItems['cpbFaceMin'];
    //   controlItems['txtProquoteCPBAmount'].max = interfaceSetupItems['cpbFaceMax'];
    //   break;
    case 'dtProquoteDob':
      if (runAll) {
        let today = new Date();
        const age30Year = today.getFullYear() - 30; // 2021-30 = 1991
        today.setFullYear(age30Year);
        updateFormData(name, today);
      }
      processMinFaceAmount(formData, controlItems, interfaceSetupItems, ageValue);
      processADBMaxFaceAmount(formData, controlItems, interfaceSetupItems, ageValue);
      processGPOMaxFaceAmount(formData, controlItems, interfaceSetupItems, ageValue);
      break;
    case 'txtProquoteFaceAmount':
      processADBMaxFaceAmount(formData, controlItems, interfaceSetupItems, ageValue);
      processGPOMaxFaceAmount(formData, controlItems, interfaceSetupItems, ageValue);
      break;
    case 'rdoProquotePaymentFrequency':
      if (
        interfaceSetupItems['isAllowDividends'] &&
        formData['rdoProquoteDividendOption'] === DivOptions.RAP
      ) {
        controlItems[name].optionItems = {
          '012': 'Choice-Annually',
          '03': 'Choice-Quarterly',
        };
      } else {
        controlItems[name].optionItems = {
          '012': 'Choice-Annually',
          '03': 'Choice-Quarterly',
          '01': 'Choice-Monthly',
        };
      }
      // setSelectBox(name, formData, updateFormData, controlItems);

      break;
    case 'rdoProquotePremiumOffset':
      if (
        !interfaceSetupItems['isAllowDividends'] ||
        formData['rdoProquoteDividendOption'] === DivOptions.RAP ||
        formData['rdoProquoteDividendOption'] === DivOptions.NONE ||
        formData['rdoProquoteDividendOption'] === ''
      ) {
        hideControlBatch([name, 'chkPremiumOffsetIllustration'], controlItems, updateControlItems);
      } else {
        showControlBatch([name, 'chkPremiumOffsetIllustration'], controlItems, updateControlItems);
        if (formData[name] === 'NT' || formData[name] === '') {
          controlItems[name].optionItems = {
            ADD: 'Choice-Add',
            NT: 'Choice-NoThanks',
          };
        } else if (formData[name] === 'ADD') {
          controlItems[name].optionItems = {
            ADDED: 'Choice-Added',
            NT: 'Choice-NoThanks',
          };
          updateFormData(name, 'ADDED');
        }
      }
      break;
    case 'rdoProquoteDividendOption':
      if (interfaceSetupItems['isAllowDividends']) {
        showControlBatch([name, 'cboDividendOption'], controlItems, updateControlItems);
        controlItems[name].optionItems = {
          [DivOptions.PUA]: 'Choice-PaidUpAdditions',
          [DivOptions.RAP]: 'Choice-AppliedPremiumPayment',
          [DivOptions.DOD]: 'Choice-LeftOnDeposit',
        };
      } else {
        hideControlBatch([name, 'cboDividendOption'], controlItems, updateControlItems);
        // controlItems[name].optionItems = {
        //   [DivOptions.NONE]: 'Choice-NoDividendsExpected',
        // };
      }
      // setSelectBox(name, formData, updateFormData, controlItems);

      break;
    case 'rdoProquoteHealthMatch':
      if (
        interfaceSetupItems &&
        interfaceSetupItems['isAllowHealthMatch'] &&
        parseInt(formData['txtProquoteFaceAmount']) >=
          interfaceSetupItems['healthMatchMinFaceAmount']
      ) {
        if (formData['rdoProquoteSmokeClass'] === 'Y') {
          controlItems[name].optionItems = {
            S: 'Choice-Standard',
            P: 'Choice-Preferred',
          };
        } else {
          controlItems[name].optionItems = {
            S: 'Choice-Standard',
            P: 'Choice-Preferred',
            U: 'Choice-UltraPreferred',
          };
        }
        showControlBatch([name, 'cboRateClass'], controlItems, updateControlItems);
      } else {
        controlItems[name].optionItems = {
          S: 'Choice-Standard',
        };
        hideControlBatch([name, 'cboRateClass'], controlItems, updateControlItems);
      }
      setSelectBox(name, formData, updateFormData, controlItems);

      break;
    case 'rdoProquoteSmokeClass':
      if (!runAll) {
        if (ageValue < 18) {
          formData[name] = 'Y';
          updateFormData(name, 'Y');
          hideControlBatch([name, 'cboSmokeClass'], controlItems, updateControlItems);
        } else {
          showControlBatch([name, 'cboSmokeClass'], controlItems, updateControlItems);
          controlItems[name].optionItems = {
            Y: 'Choice-Yes',
            N: 'Choice-No',
          };
        }
        // setSelectBox(name, formData, updateFormData, controlItems);
      }
      break;
    case 'rdoProquoteWaiver':
      if (
        interfaceSetupItems['isAllowWaiver'] &&
        ageValue >= interfaceSetupItems['waiverAgeMin'] &&
        ageValue <= interfaceSetupItems['waiverAgeMax']
      ) {
        showControlBatch([name, 'chkWaiver'], controlItems, updateControlItems);
        if (formData[name] === 'NT' || formData[name] === '') {
          controlItems[name].optionItems = {
            ADD: 'Choice-Add',
            NT: 'Choice-NoThanks',
          };
        } else if (formData[name] === 'ADD') {
          controlItems[name].optionItems = {
            ADDED: 'Choice-Added',
            NT: 'Choice-NoThanks',
          };
          // formData[name] = "ADDED";
          updateFormData(name, 'ADDED');
        }
      } else {
        hideControlBatch([name, 'chkWaiver'], controlItems, updateControlItems);
        // formData[name] = "";
        updateFormData(name, '');
      }
      // if (
      //   formData[name] === "ADDED" &&
      //   controlItems[name].disabled === false &&
      //   interfaceSetupItems['isAllowWaiverRating'] === true
      // ) {
      //   showControl('cboProquoteWaiverRating', controlItems, updateControlItems);
      // } else {
      //   hideControl('cboProquoteWaiverRating', controlItems, updateControlItems);
      // }
      break;
    case 'rdoProquoteADB':
      if (
        interfaceSetupItems['isAllowADB'] === true &&
        ageValue >= interfaceSetupItems['adbAgeMin'] &&
        ageValue <= interfaceSetupItems['adbAgeMax']
      ) {
        showControlBatch([name, 'chkADB'], controlItems, updateControlItems);
        if (formData[name] === 'NT' || formData[name] === '') {
          controlItems[name].optionItems = {
            ADD: 'Choice-Add',
            NT: 'Choice-NoThanks',
          };
        } else if (formData[name] === 'ADD') {
          controlItems[name].optionItems = {
            ADDED: 'Choice-Added',
            NT: 'Choice-NoThanks',
          };
          formData[name] = 'ADDED';
          updateFormData(name, 'ADDED');
        }
      } else {
        hideControlBatch([name, 'chkADB'], controlItems, updateControlItems);
        // formData[name] = "";
        updateFormData(name, '');
      }

      if (formData[name] === 'ADDED' && !controlItems[name].isDisabled) {
        showControlBatch(
          ['txtProquoteADBAmount', 'txtADBAmount'],
          controlItems,
          updateControlItems
        );
        // if (interfaceSetupItems['isAllowADBRating'] === true) {
        //   showControl('cboProquoteADBRating', controlItems, updateControlItems);
        // } else {
        //   hideControl('cboProquoteADBRating', controlItems, updateControlItems);
        // }
      } else {
        hideControlBatch(
          ['txtProquoteADBAmount', 'txtADBAmount'],
          controlItems,
          updateControlItems
        );
        // hideControl('cboProquoteADBRating', controlItems, updateControlItems);
      }

      break;
    case 'rdoProquoteCPB':
      if (
        interfaceSetupItems['isAllowCPB'] === true &&
        ageValue >= interfaceSetupItems['cpbAgeMin'] &&
        ageValue <= interfaceSetupItems['cpbAgeMax']
      ) {
        showControlBatch([name, 'chkCPB'], controlItems, updateControlItems);
        if (formData[name] === 'NT' || formData[name] === '') {
          controlItems[name].optionItems = {
            ADD: 'Choice-Add',
            NT: 'Choice-NoThanks',
          };
        } else if (formData[name] === 'ADD') {
          controlItems[name].optionItems = {
            ADDED: 'Choice-Added',
            NT: 'Choice-NoThanks',
          };
          formData[name] = 'ADDED';
          updateFormData(name, 'ADDED');
        }
      } else {
        hideControlBatch([name, 'chkCPB'], controlItems, updateControlItems);
        // formData[name] = "";
        updateFormData(name, '');
      }

      if (formData[name] === 'ADDED' && !controlItems[name].isDisabled) {
        showControlBatch(
          ['txtProquoteCPBAmount', 'txtCPBAmount'],
          controlItems,
          updateControlItems
        );
      } else {
        hideControlBatch(
          ['txtProquoteCPBAmount', 'txtCPBAmount'],
          controlItems,
          updateControlItems
        );
      }
      break;
    case 'rdoProquoteGPO':
      if (
        interfaceSetupItems['isAllowGPO'] === true &&
        ageValue >= interfaceSetupItems['gpoAgeMin'] &&
        ageValue <= interfaceSetupItems['gpoAgeMax']
      ) {
        showControlBatch([name, 'chkGPO'], controlItems, updateControlItems);
        if (formData[name] === 'NT' || formData[name] === '') {
          controlItems[name].optionItems = {
            ADD: 'Choice-Add',
            NT: 'Choice-NoThanks',
          };
        } else if (formData[name] === 'ADD') {
          controlItems[name].optionItems = {
            ADDED: 'Choice-Added',
            NT: 'Choice-NoThanks',
          };
          formData[name] = 'ADDED';
          updateFormData(name, 'ADDED');
        }
      } else {
        hideControlBatch([name, 'chkGPO'], controlItems, updateControlItems);
        // formData[name] = "";
        updateFormData(name, '');
      }

      if (formData[name] === 'ADDED' && !controlItems[name].isDisabled) {
        showControlBatch(
          ['txtProquoteGPOAmount', 'txtGPOAmount'],
          controlItems,
          updateControlItems
        );
        // if (interfaceSetupItems['isAllowGPORating'] === true) {
        //   showControl('cboProquoteGPORating', controlItems, updateControlItems);
        // } else {
        //   hideControl('cboProquoteGPORating', controlItems, updateControlItems);
        // }
      } else {
        hideControlBatch(
          ['txtProquoteGPOAmount', 'txtGPOAmount'],
          controlItems,
          updateControlItems
        );
        // hideControl('cboProquoteGPORating', controlItems, updateControlItems);
      }
      break;
    case 'rdoProquoteWPD':
      if (
        interfaceSetupItems['isAllowWaiverOnDeath'] === true &&
        /*formData['cboPolicyType'] !== PolicyTypesNewbiz.SINGLE*/ false &&
        ageValue >= interfaceSetupItems['waiverOnDeathAgeMin'] &&
        ageValue <= interfaceSetupItems['waiverOnDeathAgeMax']
      ) {
        showControl(name, controlItems, updateControlItems);
        if (formData[name] === 'NT' || formData[name] === '') {
          controlItems[name].optionItems = {
            ADD: 'Choice-Add',
            NT: 'Choice-NoThanks',
          };
        } else if (formData[name] === 'ADD') {
          controlItems[name].optionItems = {
            ADDED: 'Choice-Added',
            NT: 'Choice-NoThanks',
          };
          formData[name] = 'ADDED';
          updateFormData(name, 'ADDED');
        }
      } else {
        hideControlBatch([name, 'chkWPD'], controlItems, updateControlItems);
        // formData[name] = "";
        updateFormData(name, '');
      }

      // if (formData[name] === "ADDED" && !controlItems[name].isDisabled) {
      //   if (interfaceSetupItems['isAllowWaiverOnDeathRating'] === true) {
      //     showControl('cboProquoteWPDRating', controlItems, updateControlItems);
      //   } else {
      //     hideControl('cboProquoteWPDRating', controlItems, updateControlItems);
      //   }
      // } else {
      //   hideControl('cboProquoteWPDRating', controlItems, updateControlItems);
      // }
      break;
    case 'rdoProquoteAIB':
      if (
        interfaceSetupItems['isAllowAIB'] === true &&
        ageValue >= interfaceSetupItems['aibAgeMin'] &&
        ageValue <= interfaceSetupItems['aibAgeMax']
      ) {
        showControlBatch([name, 'chkAIB'], controlItems, updateControlItems);
        if (formData[name] === 'NT' || formData[name] === '') {
          controlItems[name].optionItems = {
            ADD: 'Choice-Add',
            NT: 'Choice-NoThanks',
          };
        } else if (formData[name] === 'ADD') {
          controlItems[name].optionItems = {
            ADDED: 'Choice-Added',
            NT: 'Choice-NoThanks',
          };
          formData[name] = 'ADDED';
          updateFormData(name, 'ADDED');
        }
      } else {
        hideControlBatch([name, 'chkAIB'], controlItems, updateControlItems);
        // formData[name] = "";
        updateFormData(name, '');
      }

      if (formData[name] === 'ADDED' && !controlItems[name].isDisabled) {
        showControlBatch(
          ['txtProquoteAIBOwnerAge', 'txtAIBOwnerAge'],
          controlItems,
          updateControlItems
        );
        // if (interfaceSetupItems['isAllowAIBRating'] === true) {
        //   showControl('cboProquoteAIBRating', controlItems, updateControlItems);
        // } else {
        //   hideControl('cboProquoteAIBRating', controlItems, updateControlItems);
        // }
      } else {
        hideControlBatch(
          ['txtProquoteAIBOwnerAge', 'txtAIBOwnerAge'],
          controlItems,
          updateControlItems
        );
        // hideControl('cboProquoteAIBRating', controlItems, updateControlItems);
      }
      break;

    default:
      break;
  }
}

export function GlobalCustomBusinessRules(
  name,
  user,
  controlItems,
  formData,
  elementItems,
  interfaceSetupItems,
  allSetupItems,
  updateFormData,
  updateControlItems,
  inforceData,
  runAll = false
) {
  //Note: Changing min and max in controlItems will automatically cause a re-Validation through app.js
  //console.log(`Business Rules = ${name}`);
  if (!controlItems || !controlItems[name]) {
    return;
  }
  switch (formData['formName']) {
    case 'profile':
      profileBusinessRules(
        name,
        user,
        controlItems,
        formData,
        elementItems,
        interfaceSetupItems,
        allSetupItems,
        updateFormData,
        updateControlItems,
        inforceData,
        runAll
      );
      break;
    case 'ProNeeds':
      proneedsBusinessRules(
        name,
        user,
        controlItems,
        formData,
        elementItems,
        interfaceSetupItems,
        allSetupItems,
        updateFormData,
        updateControlItems,
        inforceData,
        runAll
      );
      break;
    case 'ProQuote':
      proquoteBusinessRules(
        name,
        user,
        controlItems,
        formData,
        elementItems,
        interfaceSetupItems,
        allSetupItems,
        updateFormData,
        updateControlItems,
        inforceData,
        runAll
      );
    default:
      break;
  }

  //Some common cases
  switch (name) {
    case 'switchIllustration':
      if (elementItems[name]) {
        if (user.isNewBusiness) {
          enableControl('switchIllustration', elementItems, controlItems, updateControlItems);
        } else {
          disableControl('switchIllustration', elementItems, controlItems, updateControlItems);
        }
      }
      break;
    case 'switchInforce':
      if (elementItems[name]) {
        if (user.isInforce) {
          enableControl('switchInforce', elementItems, controlItems, updateControlItems);
        } else {
          disableControl('switchInforce', elementItems, controlItems, updateControlItems);
        }
      }
      break;
    default:
      break;
  }
}

function buildUniversityYearOptionItems(currentYear) {
  let optionItems = {};
  for (let i = 0; i < 20; i++) {
    let year = i + currentYear;
    optionItems[`0${year}`] = year;
  }
  return optionItems;
}

export function GlobalCustomBuildTrackingData(
  name,
  controlItems,
  formData,
  elementItems,
  interfaceSetupItems,
  updateFormData,
  inforceData
) {
  // let data = {...formData};
  // let key = '';
  // let val = '';
  // if (formData['formName'] === 'eApplication') {
  //   if (data['fileAttachments'].length > 0) {
  //     for (let attachment of data['fileAttachments']) {
  //       key = attachment.fileName;
  //       val = `${attachment.documentType}|${attachment.size}`;
  //       data[key] = val;
  //     }
  //   }
  //   delete data['fileAttachments'];
  //   return data;
  // }
  return null;
}

const gblOptionItems = {
  DI: 'Choice-DailyInterest',
  CBF: 'Choice-CanadianBondFund',
  CEFI: 'Choice-CanadianEquityFundIndexed',
  CEFG: 'Choice-CanadianEquityFundGrowth',
  CEFV: 'Choice-CanadianEquityFundValue',
  CSEF: 'Choice-CanadianShortTermEquityFund',
  USBF: 'Choice-USBondFund',
  USEFI: 'Choice-USEquityFund',
  APEF: 'Choice-AsiaPacificEquityFund',
};

function calculateOptions(formData, controlItems, currentRow, shared) {
  for (let i = 0; i < 4; i++) {
    let currentIndex = ((currentRow + i - 1) % 4) + 1;

    if (formData[`chk${shared}FundSelection${currentIndex}`]) {
      let tempOptions = {...gblOptionItems};
      for (let j = 1; j <= 4; j++) {
        if (j !== currentIndex && formData[`chk${shared}FundSelection${j}`]) {
          Object.keys(tempOptions).map((option) => {
            if (option === formData[`cbo${shared}FundSelection${j}`]) {
              if (
                currentRow !== currentIndex &&
                formData[`cbo${shared}FundSelection${j}`] ===
                  formData[`cbo${shared}FundSelection${currentIndex}`]
              ) {
              } else {
                delete tempOptions[option];
              }
            }
          });
        }
      }
      controlItems[`cbo${shared}FundSelection${currentIndex}`].optionItems = tempOptions;
    }
  }
  const currentCbo = `cbo${shared}FundSelection${currentRow}`;
  const currOptionArray = [...Object.keys(controlItems[currentCbo].optionItems)];
  for (let k = 1; k <= 4; k++) {
    if (k !== currentRow && formData[`chk${shared}FundSelection${k}`]) {
      if (formData[currentCbo] === formData[`cbo${shared}FundSelection${k}`]) {
        formData[currentCbo] = currOptionArray[0]; // in case of 2 combo having same value after one of them is enabled by checkbox

        //Now we have to remove this new assigned option value from other combo box options.
        for (let x = 1; x <= 4; x++) {
          if (x !== currentRow) {
            let myOptions = controlItems[`cbo${shared}FundSelection${x}`].optionItems;
            Object.keys(myOptions).map((option) => {
              if (option === formData[currentCbo]) {
                delete myOptions[option];
              }
            });
          }
        }
        break;
      }
    }
  }
}

function CalculateAllocations(formData, currentRow, shared = '') {
  let ap1, ap2, ap3, ap4;
  ap1 = parseInt(formData[`txt${shared}FundSelectionAllocationPercent1`]);
  ap2 = formData[`chk${shared}FundSelection2`]
    ? parseInt(formData[`txt${shared}FundSelectionAllocationPercent2`])
    : 0;
  ap3 = formData[`chk${shared}FundSelection3`]
    ? parseInt(formData[`txt${shared}FundSelectionAllocationPercent3`])
    : 0;
  ap4 = formData[`chk${shared}FundSelection4`]
    ? parseInt(formData[`txt${shared}FundSelectionAllocationPercent4`])
    : 0;
  let totalAllocation = ap1 + ap2 + ap3 + ap4;
  let difference = 0;
  let adjustment = 0;
  let newValue = '';
  let currentIndex = 0;
  if (totalAllocation !== 100) {
    if (totalAllocation > 100) {
      //it is reduced starting with the next field
      for (let i = 1; i <= 4; i++) {
        currentIndex = ((currentRow + i - 1) % 4) + 1;
        difference = totalAllocation - 100;
        if (formData[`chk${shared}FundSelection${currentIndex.toString()}`]) {
          adjustment = Math.min(
            parseInt(
              formData[`txt${shared}FundSelectionAllocationPercent${currentIndex.toString()}`]
            ),
            difference
          );
          totalAllocation = totalAllocation - adjustment;
          newValue = (
            parseInt(
              formData[`txt${shared}FundSelectionAllocationPercent${currentIndex.toString()}`]
            ) - adjustment
          ).toString();
          formData[
            `txt${shared}FundSelectionAllocationPercent${currentIndex.toString()}`
          ] = newValue;
        }
      }
    } else if (totalAllocation < 100) {
      //it is increased starting with the next field
      for (let i = 1; i <= 4; i++) {
        currentIndex = ((currentRow + i - 1) % 4) + 1;
        difference = 100 - totalAllocation;
        if (formData[`chk${shared}FundSelection${currentIndex.toString()}`]) {
          adjustment = difference;
          totalAllocation = totalAllocation + adjustment;
          newValue = (
            parseInt(
              formData[`txt${shared}FundSelectionAllocationPercent${currentIndex.toString()}`]
            ) + adjustment
          ).toString();
          formData[
            `txt${shared}FundSelectionAllocationPercent${currentIndex.toString()}`
          ] = newValue;
        }
      }
    }
  }
}
